export const PRODUCT_PREVIEW_HEIGHT = 40;
